import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProofSection() {
  const timeline = [{
    day: 'Día 1',
    text: 'Notarás que llegar al baño es más fácil.'
  }, {
    day: 'Día 4',
    text: 'El dolor lumbar al agacharte habrá disminuido a la mitad.'
  }, {
    day: 'Día 7',
    text: 'Te sorprenderás bajando las escaleras sin tener que sostenerte del pasamanos con ambas manos.'
  }];
  return <section className="bg-[#FDF6EE] text-stone-800 py-24 px-4" data-id="element-109">
      <div className="max-w-5xl mx-auto" data-id="element-110">
        <FadeIn data-id="element-111">
          <h2 className="text-3xl md:text-4xl font-black mb-16 text-center text-stone-900" data-id="element-112">
            ¿Qué cambia en 7 días?
          </h2>

          <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-113">
            {/* Connecting line for desktop */}
            <div className="hidden md:block absolute top-12 left-0 w-full h-1 bg-amber-200 -z-10" data-id="element-114" />

            {timeline.map((item, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-115">
                <div className="flex flex-col items-center text-center" data-id="element-116">
                  <div className="w-24 h-24 rounded-full bg-amber-100 border-4 border-amber-500 flex items-center justify-center mb-6 shadow-lg" data-id="element-117">
                    <span className="text-xl font-black text-amber-800" data-id="element-118">
                      {item.day}
                    </span>
                  </div>
                  <p className="text-lg md:text-xl text-stone-600 font-medium leading-relaxed px-4" data-id="element-119">
                    {item.text}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}